import { type JSX } from 'solid-js'

import Css from './ui.module.scss'

/** O que deu errado, dito no lugar do conteudo. */
export function ErrorNotice(props: { message: string }): JSX.Element {
    return (
        <div class={Css.error}>
            <p class={Css.errorTitle}>Não deu para carregar</p>
            <p class={Css.errorText}>{props.message}</p>
        </div>
    )
}
